import React from 'react';

import { Route, Switch, useRouteMatch } from 'react-router-dom';

import FeedbackPage from './FeedbackPage';

const FeedbackRoutes: React.FC = () => {
    const { path } = useRouteMatch();

    console.log('FeedbackRoutes path', path);
    return (
        <>
            <Switch>
                <Route exact path={`${path}`} component={FeedbackPage} />
            </Switch>
        </>
    );
};

export default FeedbackRoutes;
